import { pagingActions, changePage, changePerPage, changeSort } from './paging.actions';
import { pagingReducer, PagingState } from './paging.reducer';

export {
  pagingActions,
  changePage,
  changePerPage,
  changeSort,
  pagingReducer,
  PagingState,
}



// WEBPACK FOOTER //
// src/common/paging/index.js